module.exports = __webpack_public_path__ + "static/media/schody33 - schody drewniane zabiegowe.765ffe4a.jpg";